import ConfigPlayerModel from '../../../core/models/configplayerModel';
import parserPOCConfigPlayer from './parserPOCConfigPlayer';

export default function parserConfigPlayerFactory(config, jsonToParsed) {
  switch (config.service) {
    case 'POC':
      return parserPOCConfigPlayer(jsonToParsed);
    default:
      return new ConfigPlayerModel();
  }
}
